module.exports = __webpack_public_path__ + "media/images/lb/821-fbd24c31649f7d8d1a21db6db2e4bdac.svg";